import React from "react";
import { Box, useTheme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles(() => ({
  circle: {
    stroke: "url(#linearColors)"
  },
  circleShadow: {
    stroke: "#f5f5f5",
    filter: "url(#inset-shadow)"
  },
  textBox: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

function CircularLoaderChart({ size, value, thickness, text }) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <>
      <svg width="0" height="0">
        <linearGradient
          id="linearColors"
          x1="1"
          y1="1"
          x2="0"
          y2="0"
          gradientTransform="rotate(-105,0.5,0.5)"
        >
          <stop offset="20%" stopColor={theme.palette.primary.main} />
          <stop offset="90%" stopColor={theme.palette.secondary.main} />
        </linearGradient>
      </svg>

      <svg width="0px" height="0px">
        <filter
          id="inset-shadow"
          y="-20%"
          x="-20%"
          width="140%"
          height="140%"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#ccc" />
          <feComposite operator="out" in2="SourceAlpha" />
          <feGaussianBlur stdDeviation="0.2" />
          <feComposite operator="in" in2="SourceGraphic" />
          <feBlend mode="multiply" in="SourceGraphic" />
        </filter>
      </svg>

      <Box
        style={{
          position: "relative",
          display: "inline-flex",
          width: "fit-content"
        }}
        padding={0}
        margin={0}
      >
        <Box style={{ position: "relative" }}>
          <CircularProgress
            variant="determinate"
            classes={{ circle: classes.circleShadow }}
            size={size}
            thickness={thickness}
            value={100}
          />
          <CircularProgress
            variant="determinate"
            disableShrink
            style={{
              position: "absolute",
              left: 0
            }}
            classes={{ circle: classes.circle }}
            size={size}
            thickness={thickness}
            value={value}
          />
        </Box>
        <Box className={classes.textBox}>{text}</Box>
      </Box>
    </>
  );
}

export default CircularLoaderChart;

CircularLoaderChart.defaultProps = {
  size: 80,
  thickness: 7,
  value: 0,
  text: ""
};
